<script lang="ts" setup>
import { Menu } from '~/api/drupal/useMenu'
defineProps<{
  menu: Menu
}>()
</script>
<template>
  <div>
    <Button v-for="item in menu" :key="item.id" primary icon="arrow-left" slide :to="item.url" :target="item.target">
      {{ item.title }}
    </Button>
  </div>
</template>
<style lang="scss" scoped></style>
